<template>
    <div>
        <div style="margin-bottom: 5px">
            <el-input
                v-model="name"
                placeholder="请输入订货人姓名"
                suffix-icon="el-icon-a-042"
                style="width: 200px"
                @keyup.enter.native="loadPost"
            ></el-input>
            <el-button
                type="primary"
                style="margin-left: 5px; font-size: 18px"
                @click="loadPost"
            >
                查询</el-button
            >
            <el-button
                type="warning"
                @click="resetParam"
                style="font-size: 18px"
            >
                重置</el-button
            >

            <!-- <el-button
                type="primary"
                style="margin-left: 5px; font-size: 18px"
                @click="add"
            >
                新增</el-button
            > -->
        </div>
        <el-table
            :data="tableData"
            :header-cell-style="{ background: '#f2f5fc', color: '#555555' }"
            border
        >
            <!-- <el-table-column prop="id" label="ID" width="60"> </el-table-column> -->
            <el-table-column prop="orderNo" label="订货单号" width="150"></el-table-column>
			<el-table-column prop="userName" label="订货人" width="180"></el-table-column>
			<el-table-column prop="orderStatus" label="订货状态" :formatter="orderInfoState" width="100"></el-table-column>
			<el-table-column prop="orderTime" label="订货时间" width="150"></el-table-column>
            <el-table-column prop="remarks" label="备注" width="250"> </el-table-column>
            <!-- <el-table-column
                prop="operate"
                label="操作"
                width="400"
                fixed="right"
            >
                <template slot-scope="scope">
                    <el-button
                        style="font-size: 18px"
                        type="success"
                        @click="mod(scope.row)"
						v-if="scope.row.orderStatus==1"
                    >
                        编辑</el-button
                    >
					 <el-button
					    style="font-size: 18px"
					    type="success"
					    @click="addGoods(scope.row)"
						v-if="scope.row.orderStatus==1"
					>
					    添加商品</el-button
					> 
                    <el-button
                        slot="reference"
                        style="font-size: 18px"
                        type="danger"
						@click="showDetails(scope.row)"
                    >
                        详情</el-button
                    >
                </template>
            </el-table-column> -->
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pageNum"
            :page-sizes="[5, 10, 20, 30]"
            :page-size="pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total"
        >
        </el-pagination>
		
    </div>
</template>

<script>
export default {
    name: "UserOrderManage",
    data() {
        return {
			userOrderId:"",
			userOrderNo:"",
			tempUser:{},
			tempGoods:{},
            tableData: [],
            pageSize: 10,
            pageNum: 1,
            total: 0,
            name: "",
			innerVisible: false,
            centerDialogVisible: false,
			goodsDialogVisible:false,
			orderInfoVisible:false,
            form: {
                id: "",
                userId: "",
                userName: "",
				orderStatus:"1",
				remarks:""
            },
			orderInfo:{
				userOrderId:"",
				userOrderNo:"",
				goodsId:"",
				goodsName:"",
				goodsNum:"",
				remarks:"",
				fee:"",
				unit:""
			},
            rules: {
                userName: [
                    {
                        required: true,
                        message: "请选择下单人",
                        trigger: "blur",
                    },
                ],
            },
			orderInfoRules: {
			    goodsName: [
			        {
			            required: true,
			            message: "请选择商品",
			            trigger: "blur",
			        },
			    ],
				goodsNum: [
				    {
				        required: true,
				        message: "请输入商品数量",
				        trigger: "blur",
				    },
				],
			},
			// 1订货，2已配货，3已打码，4已送货
			orderInfoStatus:[
				{
					id:1,
					name:"已下单"
				},
				{
					id:2,
					name:"已配货"
				},
				{
					id:3,
					name:"已打码"
				},
				{
					id:4,
					name:"已送货"
				}
			]
        };
    },
	props:{
		buyOrderId:{
			type:String,
			default:""
		}
	},
	watch:{
		buyOrderId:{
			handler(newVal,oldVal){
				console.log("buyOrderIdnewVal:"+newVal)
				if(newVal){
					this.buyOrderId=newVal;
					this.loadPost()
				}
			},
			deep:true,
			immediate:true
		}
	},
    methods: {
		orderInfoState(row){
			let temp = this.orderInfoStatus.find((item) => {
			    return item.id == row.orderStatus;
			});
			
			return temp && temp.name;
		},
		showDetails(val){
			console.log(val)
			this.userOrderId=val.id;
			this.userOrderNo=val.orderNo;
			this.orderInfoVisible=true;
		},
		doSelectUser(val) {
		    console.log(val);
		    this.tempUser = val;
		},
		doSelectGoods(val){
			console.log(val);
			this.tempGoods = val;
		},
		confirmUser() {
		    this.form.userName = this.tempUser.name;
		    this.form.userId = this.tempUser.id;
		
		    this.innerVisible = false;
		},
		confirmGoods() {
		    this.orderInfo.goodsId = this.tempGoods.id;
		    this.orderInfo.goodsName = this.tempGoods.name;
			this.orderInfo.unit = this.tempGoods.unit;
		
		    this.innerVisible = false;
		},
		selectUser() {
		    this.innerVisible = true;
		},
		selectGoods(){
			this.innerVisible = true;
		},
        resetForm() {
            this.$refs.form.resetFields();
        },
        mod(row) {
            this.centerDialogVisible = true;
            this.$nextTick(() => {
                //赋值到表单
                this.form.id = row.id;
                this.form.userId = row.userId;
				this.form.userName = row.userName;
                this.form.remarks = row.remarks;
            });
        },
		addGoods(row){
			this.goodsDialogVisible = true;
			this.$nextTick(() => {
			    //赋值到表单
			    this.orderInfo.userOrderId = row.id;
				this.orderInfo.userOrderNo = row.orderNo;
			});
		},
        add() {
            this.centerDialogVisible = true;
            this.$nextTick(() => {
                this.resetForm();
            });
        },
		saveOrderInfo(){
			this.$refs.orderInfo.validate((valid) => {
			    if (valid) {
			       this.dosaveOrderInfo()
			    } else {
			        console.log("error submit!!");
			        return false;
			    }
			});
			
		},
		dosaveOrderInfo(){
			this.$axios
			    .post(this.$httpUrl + "/userorderinfo/save", this.orderInfo)
			    .then((res) => res.data)
			    .then((res) => {
			        console.log(res);
			        if (res.code == 200) {
			            this.$message({
			                message: "操作成功！",
			                type: "success",
			            });
			            this.goodsDialogVisible = false;
			            this.loadPost();
			            // this.resetForm();
			        } else {
			            this.$message({
			                message: "操作失败！",
			                type: "error",
			            });
			        }
			    });
		},
        doSave() {
            this.$axios
                .post(this.$httpUrl + "/userorder/save", this.form)
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message({
                            message: "操作成功！",
                            type: "success",
                        });
                        this.centerDialogVisible = false;
                        this.loadPost();
                        this.resetForm();
                    } else {
                        this.$message({
                            message: "操作失败！",
                            type: "error",
                        });
                    }
                });
        },
        doMod() {
            this.$axios
                .post(this.$httpUrl + "/userorder/update", this.form)
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.$message({
                            message: "操作成功！",
                            type: "success",
                        });
                        this.centerDialogVisible = false;
                        this.loadPost();
                        this.resetForm();
                    } else {
                        this.$message({
                            message: "操作失败！",
                            type: "error",
                        });
                    }
                });
        },
        save() {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    if (this.form.id) {
                        this.doMod();
                    } else {
                        this.doSave();
                    }
                } else {
                    console.log("error submit!!");
                    return false;
                }
            });
        },
        handleSizeChange(val) {
            console.log(`每页 ${val} 条`);
            this.pageNum = 1;
            this.pageSize = val;
            this.loadPost();
        },
        handleCurrentChange(val) {
            console.log(`当前页: ${val}`);
            this.pageNum = val;
            this.loadPost();
        },
        resetParam() {
            this.name = "";
        },
        loadPost() {
            this.$axios
                .post(this.$httpUrl + "/userorder/listPage", {
                    pageSize: this.pageSize,
                    pageNum: this.pageNum,
                    param: {
                        userName: this.name,
						buyOrderId:this.buyOrderId
                    },
                })
                .then((res) => res.data)
                .then((res) => {
                    console.log(res);
                    if (res.code == 200) {
                        this.tableData = res.data;
                        this.total = res.total;
                    } else {
                        alert("获取数据失败");
                    }
                });
        },
    },
    beforeMount() {
        this.loadPost();
    },
};
</script>

<style scoped>
</style>